import Image from 'next-export-optimize-images/image'

type Image = {
  image: string
  title: string
}

type ImageGridProps = {
  images: Image[]
}

const ImageGrid = ({ images }: ImageGridProps) => {
  return (
    <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 max-w-6xl">
      {images.map((stack) => (
        <div
          key={stack.title}
          className="bg-white p-4 shadow-md max-w-[80px] md:max-w-[120px]"
        >
          <Image src={stack.image} alt={stack.title} width={120} height={120} />
        </div>
      ))}
    </div>
  )
}

export default ImageGrid
